'use strict';

angular.module('clientDashboardApp').directive('infiniteScroll', function ($window, $log, $timeout) {
  return {
    restrict: 'A',
    scope: {
      data: '=',
      whenScrolled: '&'
    },
    link: function (scope, element, attrs, ngModelCtrl) {
      var rawElement = element[0];
      var checkHeightAndLoadMore = function () {
        var rectObject = rawElement.getBoundingClientRect();
        if (window.innerHeight > rectObject.bottom) {
          scope.whenScrolled();
        }
      };
      angular.element($window).bind('scroll', checkHeightAndLoadMore);

      scope.$on('$destroy', function () {
        angular.element($window).unbind('scroll', checkHeightAndLoadMore);
      });

      scope.$watch('data', function (newVal, oldVal) {

        $timeout(
          // give time to render proper I guess. $scope.$async was coming up with height larger than the actual height
          () => checkHeightAndLoadMore(),
          200
        );
      })


    }
  };
});
